export const URL_API = "https://api.sigta.uap.edu.bo/";
//export const URL_API = "http://192.168.4.75:9994";
export const NAME_LOCALSTORAGE_TOKEN = "Tktr4m1t3s01";
export const VERSION_APP = "1.3.1";
